import type { IntegrationRequestFormSchema } from '../../../../models/IntegrationRequest';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

export interface CheckboxOption {
  value: string;
  label: string;
  hint?: string;
}

type CheckboxListFieldName = 'branchIds' | 'serviceWithOperatorIds';

interface CheckboxListFieldProps {
  control: Control<IntegrationRequestFormSchema>;
  name: CheckboxListFieldName;
  options: CheckboxOption[];
  emptyMessage: string;
  disabled?: boolean;
}

const toggleValue = (values: string[], value: string): string[] =>
  values.includes(value) ? values.filter((item) => item !== value) : [...values, value];

const CheckboxListField = ({
  control,
  name,
  options,
  emptyMessage,
  disabled = false,
}: CheckboxListFieldProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState }) => (
      <div className='flex flex-col'>
        {options.length === 0 && <p className='text-sm text-gray-500'>{emptyMessage}</p>}
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            label={
              <span className='text-sm text-gray-800'>
                {option.label}
                {option.hint && <span className='text-gray-500'> · {option.hint}</span>}
              </span>
            }
            control={
              <Checkbox
                size='small'
                checked={field.value.includes(option.value)}
                disabled={disabled}
                onChange={() => field.onChange(toggleValue(field.value, option.value))}
              />
            }
          />
        ))}
        {fieldState.error?.message && (
          <p className='text-xs text-red-600'>{fieldState.error.message}</p>
        )}
      </div>
    )}
  />
);

export default CheckboxListField;
